exports.convertStringArrayToObjectArray = values => {
  // keyValue pair does not work
  // const list = []
  // values.forEach(e => list[e+''] = e+'')
  // return list
  return values && values.length ? values.map(e => ({ 
    label: e+'',
    value: e+'',
    key: e+''
  })) : []
}

exports.convertToDropDown = (values,keys) => {
  if(keys && keys.length){
    if(values && values.length){
      return values.map(e => ({
        label : `${e[keys[0]]}`,
        value : `${e[keys[0]]}`
      }))   
    } else{
      return [];
    } 
  }else{
    return [];
  } 
}

exports.getSelectedTemplate = (selectedTemp) => {
  return (
    {
    "cashAccPfId": selectedTemp.cashAccPfId,
    "cashAccNo": selectedTemp.cashAccNo,
    "amount": selectedTemp.amount,
    "remarks": selectedTemp.remarks,
    "costTypeKey": selectedTemp.costTypeKey,
    "currencyKey": selectedTemp.currencyKey,
    "currencyTech": selectedTemp.currencyTech,
    "beneficiaryId": selectedTemp.beneficiaryId,
    "toCashAccPfId": selectedTemp.toCashAccPfId,
    "toCashAccNo": selectedTemp.toCashAccNo
    })
}

exports.getModifiedTemplateObject = ({ amount, remarks, from, to, currency, cost, templateName}) => {
  const templateobj = { 
    "cashAccPfId": from.pfId,
    "cashAccNo": from.accNo,
    "amount": amount,
    "remarks": remarks,
    "costTypeKey": (cost && cost.costTypeKey)?cost.costTypeKey: null,
    "currencyKey": currency.currencyKey,
    "currencyTech": currency.tech,
    "beneficiaryId": to.beneficiaryId || null,
    "toCashAccPfId": to.pfId || null,
    "toCashAccNo": to.accNo || null
  }
  return templateobj;
}

// Function to add label property to each object in the array
// (dbk component accepts in label and value)
exports.convertKeyToLabelArray = (inputArray) => {
  if (Array.isArray(inputArray) && inputArray.length) {
    return inputArray.map(item => ({
      ...item,
      label: item.value
    }));
  }
  return [];
};

exports.convertKeyToLabelArrayForInitiator = (inputArray, currentUserId) => {
  let result = [];
  if (Array.isArray(inputArray) && inputArray.length) {
    const filteredArrayWithoutCurrentUsr = inputArray.filter(item => item.key !== currentUserId);
    result = filteredArrayWithoutCurrentUsr.map(item => ({
      ...item,
      label: item.key + (item.value ? ` (${item.value})` : ''),  
    }));
  }

  if (currentUserId) {
    result.push({
      label: currentUserId + ` (myself)`,
      value: currentUserId,
      key: currentUserId
    });
  }
  return result;
};

exports.convertAndSortDropDown = (values, keys) => {
  if(keys && keys.length){
    if(values && values.length){
      return values.map(e => ({
        label : `${e[keys[0]]} (${e[keys[2]]})`,
        value : `${e[keys[1]]}`,
        key: `${e[keys[0]]}`,
      })).sort((a, b) => {
      // Extract the string inside parentheses from the label
      const aStr = a.label.match(/\(([^)]+)\)$/)[1];
      const bStr = b.label.match(/\(([^)]+)\)$/)[1];
      return aStr.localeCompare(bStr); // Ascending order
    });  
    } else{
      return [];
    } 
  }else{
    return [];
  } 
}

exports.convertCurrencyDropdown = (inputArray) => {
 if (Array.isArray(inputArray) && inputArray.length) {
    return inputArray.map(item => ({
      label: `${item.key} - ${item.value}`,
      ...item
    }));
  }
  return [];
}

exports.validateConfirmationAmount = (amtToCheck, referenceAmount) =>{  
  let confirmationAmtFormat = new RegExp("^\\d+(\\.\\d{0,2}|)$");
  let match = confirmationAmtFormat.test(amtToCheck) && parseFloat(amtToCheck) === parseFloat(referenceAmount);

  return match
    
}